import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import {PaqueteSeguros} from '../_models/paquete-seguros';
import {GarantiasIdoneas} from '../_models/garantias-idoneas';
import {GarantiasIdoneasDestino} from '../_models/garantias-idoneas-destino';
import {GarantiasIdoneasMunicipio} from '../_models/garantias-idoneas-municipio';
import {GarantiasIdoneasProducto} from '../_models/garantias-idoneas-producto';
import {GarantiasIdoneasActividades} from '../_models/garantias-idoneas-actividades';
import {Observable} from 'rxjs';
import {GarantiasIdoneasPeriodoGracia} from '../_models/garantias-idoneas-periodo-gracia';
import {GarantiasIdoneasPeriodoGraciaConceptoFacturacion} from '../_models/garantias-idoneas-periodo-gracia-concepto-facturacion';
@Injectable({
  providedIn: 'root'
})
export class GarantiaIdoneasPeriodoGraciaConceptosFacturacionService{
  private rutServicio = AppSettings.rutServiciosAPL + '/api/garantiasIdoneasPGConceptosFacturacion';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as GarantiasIdoneasPeriodoGraciaConceptoFacturacion[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as GarantiasIdoneasPeriodoGraciaConceptoFacturacion[] ) );
  }

  listadoPorPeriodoConpecto(id: string) {
    return this.httClient.get( this.rutServicio + '/garantiaIdonea/' + id ).pipe( map( res => res as GarantiasIdoneasPeriodoGraciaConceptoFacturacion[] ) );
  }

  listadoPorPeriodoConpectoActivos(id: string) {
    return this.httClient.get( this.rutServicio + '/garantiaIdonea/' + id + '/enabled').pipe( map( res => res as GarantiasIdoneasPeriodoGraciaConceptoFacturacion[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as GarantiasIdoneasPeriodoGraciaConceptoFacturacion ) );
  }

  crear( regCrear: GarantiasIdoneasPeriodoGraciaConceptoFacturacion ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as GarantiasIdoneasPeriodoGraciaConceptoFacturacion ) );
  }

  actualizar( regActualizar: GarantiasIdoneasPeriodoGraciaConceptoFacturacion ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }

  bulk( segmentoActividades: GarantiasIdoneasPeriodoGraciaConceptoFacturacion[] ): Observable<GarantiasIdoneasPeriodoGraciaConceptoFacturacion[]> {
    segmentoActividades.map( sa => {
      sa.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    } );
    return this.httClient.post( this.rutServicio + '/bulk', segmentoActividades ).pipe( map( res => res as GarantiasIdoneasPeriodoGraciaConceptoFacturacion[] ) );
  }
}
